import { RichTextValue, TextBox } from '@/components';
import { useGetAnnouncementDetailsQuery } from '@/redux/announcements';
import { useTranslation } from 'react-i18next';
import { formatters } from '@/core';

interface Props {
  id: string;
}

export function AnnouncementDetailsPanel(props: Props) {
  const { id } = props;
  const { t } = useTranslation();
  const { data } = useGetAnnouncementDetailsQuery({ id });

  if (!data) {
    return null;
  }

  return (
    <>
      <TextBox label={t('announcements.details.title')}>{data.title}</TextBox>
      <TextBox label={t('announcements.details.startDate')}>
        {formatters.dateTime(data.period.start, 'date', { applyOffset: false })}
      </TextBox>
      <TextBox label={t('announcements.details.endDate')}>
        {data.period.end
          ? formatters.dateTime(data.period.end, 'date', { applyOffset: false })
          : '-'}
      </TextBox>
      <RichTextValue
        label={t('announcements.details.body')}
        value={data.body}
        ownerId={data.id}
        ownerType="Announcement"
      />
    </>
  );
}
